import React, { Fragment, useEffect, useState } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import { Box, Button, Grid, Paper } from "@mui/material/";
import Spinner from "../../templates/Spinner";
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Table from '@mui/material/Table';
import tableCellClasses from '@mui/material/TableCell';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { getFileBase64, gExtTramitedet } from "../../../service/service.supersalud";
import RenderFile from "../renderFile/renderFile";

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },

}));

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
        padding: "0px 0px",

    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 5,
    },
}));

const ModalSolicitudes = (props) => {
    const { user, recActivo, userLogOut, userLoggedIn } = props;
    const { innerWidth: width /*, innerHeight: height*/ } = window;
    const history = useHistory();
    const classes = useStyles();
    const [tramite, setTramite] = useState(null);
    const [url, setUrl] = useState(undefined);

    const [loading, setLoading] = useState(false);

    const logout = () => {
        userLogOut();
        history.push("/login");
    };


    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 800,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };

    const [open, setOpen] = React.useState(false);
    // const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    useEffect(
        () => {

            if (recActivo !== '') {
                setLoading(true)
                getTramiteDetSol(recActivo)
            }
        },
        // eslint-disable-next-line
        [recActivo]
    )

    const getTramiteDetSol = async (item) => {

        let raw = JSON.stringify({
            rut: item.run_rec,
            folio: item.folio,
            clasificacion: item.clasificacion
        })

        const resp = await gExtTramitedet(user, logout, userLoggedIn)(raw);
        const resp_status = await resp.status;

        if (resp_status !== 200 && resp_status !== 401) { //quiere decir que falló la solicitud
            userLogOut();
            return history.push("/login");
        } else {
            let results = await resp.json();

            let aux = {
                ...results,
                ux: recActivo.ux
            }
            setTramite(aux)
        }
        setLoading(false)

    }

    const verArchivo = async (reclamo) => {
       
        let rutAux = 'No aplica'

        if (tramite.run_rec !== 'N/A') {
            rutAux = tramite.run_rec
        }

        let aux = {
            folio: tramite.folio,
            token: reclamo.id,
            indice: tramite.ux,
            rut: rutAux

        }

        const url = await getFileBase64(user, userLogOut, userLoggedIn)(aux)
       
        if(url){
            setUrl(url);
        }

        /*         let aux = {
                  ...reclamo,
                  identifier: reclamo.run_rec,
            
                }
                const url = await getCertificate(user, logout, userLoggedIn)(aux);
                if (url) {
                  setUrl(`data:application/pdf;base64,${url}`);
                } */
    };

    const getPrioridad = () => {
        if (tramite.prioridad === 1) {
            return 'Alta'
        }
        if (tramite.prioridad === 2) {
            return 'Media'
        }
        if (tramite.prioridad === 3) {
            return 'Baja'
        }

    }

    const getXsFiles = () => {
        if(width>500){
            return 3
        }else{
            return 6
        }
    }

    const renderFiles = () => {

        if (tramite.files.length === 0) {
            return null
        } else {
            return (
                <>
                    <h1

                        style={{
                            fontSize: 18,
                            fontWeight: "bold",
                            textAlign: "left",
                            paddingTop: "20px",
                        }}
                    >
                        Archivos
                    </h1>
                    <Box

                        flexDirection="row"
                        pb={1}
                        style={{ textAlign: "justify" }}
                    >
                        {/* mapear los archivos, crear vista y decodificar en nueva ventana */}
                        <Grid container>
                            {
                                tramite.files.map((item, index) => {
                                    return <Grid item xs={getXsFiles()} key={index}>
                                        <Button
                                            disableElevation
                                            onClick={() => { verArchivo(item) }}
                                            variant="contained"
                                            color="primary"
                                            className={classes.submit}
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="24"
                                                height="24"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                                stroke="#FFFFFF"
                                                stroke-width="1"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            >
                                                <path d="M15.475,6.692l-4.084-4.083C11.32,2.538,11.223,2.5,11.125,2.5h-6c-0.413,0-0.75,0.337-0.75,0.75v13.5c0,0.412,0.337,0.75,0.75,0.75h9.75c0.412,0,0.75-0.338,0.75-0.75V6.94C15.609,6.839,15.554,6.771,15.475,6.692 M11.5,3.779l2.843,2.846H11.5V3.779z M14.875,16.75h-9.75V3.25h5.625V7c0,0.206,0.168,0.375,0.375,0.375h3.75V16.75z"></path>
                                            </svg>{" "}
                                            {item.filename}
                                        </Button>
                                    </Grid>
                                })
                            }

                        </Grid>
                    </Box>
                </>
            )
        }

    }

    const gestExternaView = () => {
        return (
            <>
                <h1 style={{ fontSize: 18, fontWeight: "bold", textAlign: "left", padding: 4, marginTop: 10 }}>Monitoreo de solicitud externa</h1>
                <Table style={{ padding: 4, marginTop: 0 }}>
                    <TableBody>

                        <StyledTableRow key={0}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Solicitante:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.usuario_solicitante === "" ? "N/A" : tramite.usuario_solicitante}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={1}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Etapa:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.etapa}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={2}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Fecha ingreso:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.fecha_ingreso}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={3}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Fecha etapa:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.fecha_etapa}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={4}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Vencimiento:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.vencimiento}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={5}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Prioridad:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{getPrioridad()}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={6}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Solicitud:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.solicitud}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={7}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Responsable:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.usuario_responsable}</StyledTableCell>
                        </StyledTableRow>

                    </TableBody>

                </Table>
                <h1
                    hidden={tramite.observaciones === '' ? true : false}
                    style={{
                        fontSize: 18,
                        fontWeight: "bold",
                        textAlign: "left",
                        paddingTop: "20px",
                    }}
                >
                    Observaciones de la solicitud
                </h1>
                <Box
                    hidden={tramite.observaciones === '' ? true : false}
                    flexDirection="row"
                    pb={1}
                    style={{ textAlign: "justify" }}
                >
                    {tramite.observaciones}
                </Box>
                {renderFiles()}
            </>
        )
    }

    const gestInternaView = () => {
        return (
            <>
                <h1 style={{ fontSize: 18, fontWeight: "bold", textAlign: "left", padding: 4, marginTop: 10 }}>Monitoreo de solicitud interna</h1>
                <Table style={{ padding: 4, marginTop: 0 }}>
                    <TableBody>

                        <StyledTableRow key={0}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Solicitante:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{ ((tramite.usuario_solicitante ===null) ||  ( tramite.usuario_solicitante === ""))? "N/A" : tramite.usuario_solicitante}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={1}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'R.U.T. Solicitante:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.rut_reclamante}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={2}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Etapa:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.etapa}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={3}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Fecha ingreso:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.fecha_ingreso}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={4}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Fecha etapa:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.fecha_etapa}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={5}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Vencimiento:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.vencimiento}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={6}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Prioridad:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{getPrioridad()}</StyledTableCell>
                        </StyledTableRow>
                        <StyledTableRow key={7}>
                            <StyledTableCell style={{ padding: 4 }}><Typography color="textSecondary" gutterBottom variant="subtitle2">{'Observación:'} </Typography> </StyledTableCell>
                            <StyledTableCell align="left" style={{ padding: 4 }}>{tramite.solicitud}</StyledTableCell>
                        </StyledTableRow>


                    </TableBody>
                </Table>
                <h1
                    hidden={tramite.observaciones === '' ? true : false}
                    style={{
                        fontSize: 18,
                        fontWeight: "bold",
                        textAlign: "left",
                        paddingTop: "20px",
                    }}
                >
                    Solicitud
                </h1>
                <Box
                    hidden={tramite.observaciones === '' ? true : false}
                    flexDirection="row"
                    pb={1}
                    style={{ textAlign: "justify" }}
                >
                    {tramite.observaciones}
                </Box>
            </>
        )
    }

    const getSolView = () => {
        if (tramite.clasificacion === 'gestion_externa') {
            return (gestExternaView())
        }
        if (tramite.clasificacion === 'gestion_interna') {
            return (gestInternaView())
        }
    }

    const getPadding = () =>{
        if(width>500){
            return 10
        }else{
            return 0
        }
    
    }

    return (
        <Fragment>

            {loading ?
                (
                    <Spinner />
                )
                :
                (
                    <Grid
                        container
                        direction="row"
                        justifyContent="center"
                        alignItems="center"
                        style={{
                            backgroundImage: `url("https://rnpi.superdesalud.gob.cl/app/images/3.png")`,
                        }}
                    >
                        <Grid item xs={10} sm={8} className={classes.section}>
                            <Box pl={2} color={"rgb(97,97,97,0.9)"}>
                                <h1
                                    style={{
                                        fontSize: 22,
                                        fontWeight: "bold",
                                        textAlign: "Left",
                                        paddingTop: "30px",
                                        paddingLeft: "0px",
                                        paddingBottom: "5px",
                                    }}
                                >
                                    Trámite - {recActivo.folio} {/* folio */}
                                </h1>

                                <Paper>

                                    <Grid item xs={12} sm={11}>
                                        <Box flexDirection="row" pl={getPadding()} pt={2}>
                                            {tramite ? (
                                                <>
                                                    <Box>
                                                        {getSolView()}
                                                    </Box>

                                                    <br></br>
                                                </>
                                            )
                                                :
                                                (
                                                    <Grid item xs={12} sm={10}>
                                                        <Box>
                                                            <h3 style={{ fontSize: 14 }}>No posee Recursos</h3>
                                                        </Box>
                                                    </Grid>
                                                )
                                            }
                                        </Box>
                                    </Grid>
                                </Paper>
                            </Box>
                        </Grid>
                    </Grid>
                )}
            {!!url ? <RenderFile {...{ url, setUrl }} /> : null}
        </Fragment>
    );
};
export default ModalSolicitudes;

const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        margin: "30px",
    },
    button: {
        marginRight: theme.spacing(1),
    },
    instructions: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    sectionTitle: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    sectionDetails: {
        marginLeft: theme.spacing(4),
        marginRight: theme.spacing(4),
    },
    titleAccordion: {
        margin: "5px 0px",
        BorderColor: "#0064AC",
        // backgroundColor: '#0064AC',
    },
    titleAccordionText: {
        fontSize: "18px",
        fontWeight: "bold",
        textAlign: "left",
        padding: 4,

        marginTop: "10px",
    },

    TimelineIcon: {
        color: "#FFFFFF",
        marginTop: "20px",
        marginRight: "8px",
        fontSize: "18px",
    },
    searchText: {
        flex: "0.8 0",
    },
    clearIcon: {
        "&:hover": {
            color: theme.palette.error.main,
        },
    },
}));